__turbopack_context__.v({
  "cta": "projects-cta-module__KuFf3G__cta",
  "label": "projects-cta-module__KuFf3G__label",
});
